<p style="margin-left: 15px;">{{this.text}} </p>
<span style="margin:auto; display:table;">{{this.header}}</span>
<div #chartContainer class="chart-container-area"></div>